module.exports = __webpack_public_path__ + "static/media/netfit_logo.8a8ba670.png";